<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-card v-for="appl,index in app_list" :key="index" @click="startApp(appl.shortcut)"
                        cols="12" sm="6" md="4" lg="3" xl="2"
                        style="width:300px;min-height:100px;margin:20px;cursor:pointer"
                        variant="outlined">
                        <v-card-title>{{appl.app_name}}</v-card-title>
                        <v-card-text>{{appl.app_description}}</v-card-text>
                </v-card>
            </v-row>            
        </v-card-text>
    </v-card>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            app_list : null,
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getApplications()
        },
        getApplications() {
            axios.get('/get-public-applications', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.app_list = res.data.list                    
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        startApp(_app) {
            switch (_app) {
                case "studyplan": this.$router.push({name : 'stud_plan'})
                             break
            }
        }

    }
}
</script>

<style>

</style>